function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.05 3.757a1 1 0 000 1.415L5.88 8 3.05 10.828a1 1 0 000 1.415l.707.707a1 1 0 001.415 0L8 10.12l2.829 2.829a1 1 0 001.414 0l.707-.707a1 1 0 000-1.415L10.12 8l2.829-2.828a1 1 0 000-1.415l-.707-.707a1 1 0 00-1.415 0L8 5.88 5.172 3.05a1 1 0 00-1.415 0l-.707.707z",
  fill: "currentColor"
})));